/**
 * AL QUE SE LE DA DE BAJA CON LA APP ABIERTA SE LE DICE POR QUÉ SALE (14-10, BAJ-12).
 *
 * Con la cuenta dada de baja el servidor contesta 403 "Cuenta desactivada" a todo
 * (`backend/core/security.get_current_user`). La app cerraba la sesión y lo dejaba en la
 * pantalla de entrada sin una frase: parecía una sesión caducada y volvía a probar su
 * contraseña. Aquí se reconoce ese 403 y se deja un recado para la pantalla de entrada, que
 * enseña el mismo aviso fijo que al intentar entrar.
 *
 * El recado va en sessionStorage: es de esta pestaña y se borra al leerlo.
 */
const CLAVE = 'cuenta_de_baja';

/** ¿Este error es el 403 de una cuenta dada de baja? Un 403 de permisos no lo es. */
export const esCuentaDeBaja = (error) => {
    const detalle = error?.response?.data?.detail;
    return error?.response?.status === 403
        && typeof detalle === 'string' && detalle.startsWith('Cuenta desactivada');
};

export const apuntarCuentaDeBaja = () => {
    try { sessionStorage.setItem(CLAVE, '1'); } catch { /* sin almacén, sale sin la frase */ }
};

/** ¿Hay recado? Solo lee (se puede llamar al pintar). */
export const hayCuentaDeBaja = () => {
    try { return sessionStorage.getItem(CLAVE) === '1'; } catch { return false; }
};

/** Leído el recado, se borra: el aviso sale una vez, no en cada visita a la entrada. */
export const olvidarCuentaDeBaja = () => {
    try { sessionStorage.removeItem(CLAVE); } catch { /* nada que hacer */ }
};
